module.exports = __webpack_public_path__ + "media/fonts/suisse-intl/SuisseIntl-BlackItalic-WebS-f21b8cca4137434caadc5fc5be0ae92e.woff2";